import {combineReducers} from "redux";

import {IAppError, reduceLatestQuery, reduceRequestErrors, reduceRequestState, reduceResponse, RequestState} from "@pg-mono/request-state";

import {ILatestQuery} from "../../../utils/latest_query";
import {fetchPropertiesCountTypes} from "../../list/actions/fetch_properties_count";
import {fetchDesktopMapOfferListTypes} from "../actions/fetch_map_offer_list";

export interface IOfferListMapListStore {
    requestState: RequestState;
    latestQuery: ILatestQuery;
    error: IAppError | null;
    propertiesCount: number | null;
}

export const offerListMapListReducer = combineReducers({
    requestState: reduceRequestState(fetchDesktopMapOfferListTypes),
    latestQuery: reduceLatestQuery(fetchDesktopMapOfferListTypes),
    error: reduceRequestErrors(fetchDesktopMapOfferListTypes),
    propertiesCount: reduceResponse<number>(fetchPropertiesCountTypes)
});
